import * as index from '~/index';
import _utils from '~/utils/general';
import _entities from '~/entities/index';
import _plugins from '~/plugins/index';

import log from '~/log.js';


/** @ignore */
const TAG = 'Bootstrap';



/**
 * Plugins
 * @type {src/plugins/index.js~Plugins}
 */
export let plugins = _plugins;

/**
 * Entities
 * @type {src/entities/index.js~Entities}
 */
export let entities = _entities;

/**
 * General utilities
 * @type {src/utils/general.js~GeneralUtils}
 */
export let utils = _utils;



/**
 * Main libary entry point.
 */
export default index;


log.send(log.DEBUG, TAG, 'Initialized.');



// For docs
/** @external {js-money} https://www.npmjs.com/package/js-money */
/** @external {evee} https://www.npmjs.com/package/evee */
/** @external {promise-queue} https://www.npmjs.com/package/promise-queue */



// WEBPACK FOOTER //
// ./src/index.js